"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="branch-list-page">
    <crud-table title="${'branch.list.title'.t()}" addText="${'branch.create'.t()}" resource="onboarding" searchPlaceholder="${'branch.search.placeholder'.t()}"
      listEndpoint="branch.list" deleteEndpoint="branch.delete" queryParam="q"
      editRoute="/branch/form/:id" addRoute="/branch/form" :columns="${x => x.tableColumns}">
    </crud-table>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.branch-list-page .color-preview {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  margin-right: 8px;
  border: 1px solid #ddd;
  display: inline-block;
  vertical-align: middle;
}`;
const shadowOptions = { "mode": "open" };
let BranchList = class BranchList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            {
                key: 'name',
                header: 'branch.name'.t()
            },
            {
                key: 'description',
                header: 'branch.description'.t(),
                formatter: (description) => description || '-'
            },
            {
                key: 'color',
                header: 'branch.color'.t(),
                formatter: (color) => {
                    if (!color)
                        return '-';
                    return `<div style="display: inline-flex; align-items: center;">
                    <div style="width: 20px; height: 20px; background-color: ${color}; border-radius: 3px; margin-right: 8px; border: 1px solid #ddd;"></div>
                    ${color}
                </div>`;
                }
            }
        ];
    }
};
exports.BranchList = BranchList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BranchList.prototype, "tableColumns", void 0);
exports.BranchList = BranchList = __decorate([
    (0, client_1.RWSView)('branch-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], BranchList);
BranchList.defineComponent();
